import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

import LoadingButton from '@components/atoms/loadingButton';

export const AvailableBox = withTheme(styled(Box)`
  @media only screen and (max-width: 1199px) and (min-width: 768px) {
    margin-bottom: -20px;
    display: flex;
    flex-direction: column;
  }
`);

export const AvailableButtonStyle = withTheme(styled(LoadingButton)`
  && {
    white-space: nowrap;
    font-size: ${(props: any) => (props.fontSize || props.isFooter ? '18px' : '24px')};
    font-weight: 500;
    background: white;
    height: ${(props: any) => (props.height || props.isFooter ? '40px' : '60px')};
    color: ${(props: any) => props.theme.palette.primary.main};
    :hover {
      opacity: 0.9;
      background-color: white;
    }
    &&.Mui-disabled {
      color: #0000001f;
    }
  }
`);
